module.exports = __webpack_public_path__ + "static/media/Schedule-amico.e131da75.png";